import { render, staticRenderFns } from "./ModelAdminDown.vue?vue&type=template&id=4e422f37&scoped=true"
import script from "./ModelAdminDown.vue?vue&type=script&lang=js"
export * from "./ModelAdminDown.vue?vue&type=script&lang=js"
import style0 from "./ModelAdminDown.vue?vue&type=style&index=0&id=4e422f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e422f37",
  null
  
)

export default component.exports